import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
const EditEventPage = ({ event, onClose, onSubmit }) => {
  console.log(event.created_by);
  const [eventData, setEventData] = useState({});
  const [options, setOptions] = useState([]);
  const [loms, setLoms] = useState([]);
  const [catOptions, setCatOptions] = useState([]);
  useEffect(() => {
    fetchZoneTrainers();
    fetchLoms();
    fetchTopics();
    if (event) {
      // Pre-fill the form with event details
      setEventData({
        lom_name: event.lom_name || "",
        event_name: event.event_name || "",
        category: event.category || "",
        event_date: formatDate(event.event_date) || "",
        event_time: event.event_time || "",
        duration: event.duration || "",
        event_location: event.event_location || "",
        last_date: event.last_date || "",
        event_topic: event.event_topic,
        zone_trainer_id: event.zone_trainer_id,
        created_by: event.created_by,
      });
    }
  }, []);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const user_type = sessionStorage.getItem("profession_id");
  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Adding leading zero if month < 10
    const day = String(d.getDate()).padStart(2, "0"); // Adding leading zero if day < 10
    return `${year}-${month}-${day}`;
  };
  const fetchTopics = async () => {
    try {
      const response = await axios.get("/event_topics/get_all");
      setCatOptions(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };
  const handleTrainerChange = (selectedOptions) => {
    // If selectedOptions is an array of objects, we extract the values (e.g., ["8", "24"])
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => Number(option.value)) // Ensure values are strings
      : [];

    console.log("Selected values: ", selectedValues);

    // Update eventData with the new zone_trainer_id values
    setEventData((prevData) => {
      console.log("Prev state:", prevData);
      return {
        ...prevData,
        zone_trainer_id: selectedValues, // Update with the selected values as an array of strings
      };
    });
  };
  const handleCategoryChange = (selected) => {
    setEventData((prevState) => ({
      ...prevState,
      event_topic: selected ? selected.value : "",
    }));
  };

  const handleLomChange = (selected) => {
    setEventData((prevState) => ({
      ...prevState,
      created_by: selected ? selected.value : "",
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEventData({ ...eventData, [name]: value });
  };

  const lomoptions = [
    { value: "admin", label: "All" }, // Add this as the first option
    ...loms.map((lom) => ({
      value: lom.lom_id,
      label: lom.lom_name,
    })),
  ];
  const fetchZoneTrainers = async () => {
    try {
      const response = await axios.get("/zone_trainer/get_all");
      setOptions(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };
  const fetchLoms = async () => {
    try {
      const response = await axios.get("/lom/read");
      setLoms(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };
  // const catOptions = [
  //   { value: "Category 1", label: "Category 1" },
  //   { value: "Category 2", label: "Category 2" },
  //   { value: "Category 3", label: "Category 3" },
  // ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      // PUT request to update event by eventId
      const response = await axios.put(
        `/events/update/${event.event_id}`,
        eventData
      );
      console.log("Event updated:", response.data);

      Swal.fire({
        icon: "success",
        title: "Event Updated",
        text: "The event has been updated successfully!",
        confirmButtonText: "Okay",
      });

      onSubmit(); // Refresh event list after successful edit
      onClose(); // Close the Edit Event popup
    } catch (err) {
      setError(err.response?.data?.error || "Failed to update event");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-4xl shadow-lg max-h-full overflow-y-auto">
        <h2 className="text-lg font-bold mb-4">Edit Event</h2>
        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-4"
        >
          {/* Program Name Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Program Name
            </label>
            <input
              type="text"
              name="event_name"
              value={eventData.event_name}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg"
              required
            />
          </div>

          {/* Category Dropdown */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Category
            </label>
            <Select
              name="event_topic"
              value={catOptions.find(
                (option) => String(option.value) === eventData.event_topic
              )}
              onChange={handleCategoryChange}
              options={catOptions}
              className="w-full p-2 border rounded-lg"
              required
            />
          </div>

          {/* Created for (conditional) */}
          {user_type === "2" || user_type === "1" ? (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Created for
              </label>
              <Select
                name="created_by"
                value={lomoptions.find(
                  (option) => String(option.value) === eventData.created_by
                )}
                onChange={handleLomChange}
                options={lomoptions}
                className="w-full p-2 border rounded-lg"
                required
              />
            </div>
          ) : null}

          {/* Event Date */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Event Date
            </label>
            <input
              type="date"
              name="event_date"
              value={eventData.event_date}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg"
              required
            />
          </div>

          {/* Event Time */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Event Time
            </label>
            <input
              type="time"
              name="event_time"
              value={eventData.event_time}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg"
              required
            />
          </div>

          {/* Event Duration */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Event Duration (hrs)
            </label>
            <input
              type="number"
              name="duration"
              value={eventData.duration}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg"
              required
            />
          </div>

          {/* Event Location */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Event Location
            </label>
            <input
              type="text"
              name="event_location"
              value={eventData.event_location}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg"
              required
            />
          </div>

          {/* Last Date to Apply */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Last Date to Apply
            </label>
            <input
              type="date"
              name="last_date"
              value={eventData.last_date}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg"
              required
            />
          </div>

          {/* Zone Trainers */}
          {/* <div className="md:col-span-2"> */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Zone Trainers
            </label>
            <Select
              isMulti
              options={options}
              value={options.filter(
                (option) =>
                  eventData.zone_trainer_id &&
                  eventData.zone_trainer_id.includes(Number(option.value))
              )}
              name="zone_trainer_id"
              onChange={handleTrainerChange}
            />
          </div>

          {/* Action Buttons */}
          <div className="md:col-span-2 flex justify-end space-x-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 text-black rounded-lg"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded-lg"
              disabled={loading}
            >
              {loading ? "Editing..." : "Edit Event"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEventPage;
